// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"0ef48e2f","787":"890e5f70"}[chunkId] + ".chunk.js";
};